var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes},_vm._l((_vm.results),function(result){return _c('ThumbnailPolaroid',{key:result.id,attrs:{"submission":result,"numbered":_vm.numbered,"wall":_vm.wall},on:{"click":_vm.select}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }